import { Typography, Button } from '@ui/components';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { Plus } from '@ui/components/icons';

import { UserInviteSidebar } from '../user-invite-sidebar/user-invite-sidebar';

export const UsersHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between mb-4">
      <Typography variant="h300" element="h1">
        {t('USERS.TITLE')}
      </Typography>

      <HasPermission permissionFeature="COMPANY_ACCOUNT_INVITE_USER" permissionType="WRITE">
        <UserInviteSidebar>
          <Button variant="primary">
            <Plus />
            {t('USERS.ADD_USER')}
          </Button>
        </UserInviteSidebar>
      </HasPermission>
    </div>
  );
};
